import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

const GetAlertsSummaryResponseDtoSchema = PagePaginationResponseDtoSchema(
  z.object({
    facilityId: z.number(),
    facilityName: z.string(),
    avgResidents: z.number(),
    createdAlerts: z.number(),
    alertsPerResident: z.number().nullish(),
    createdFlags: z.number(),
    avgDaysToClose: z.number().nullish(),
    activeAlerts: z.number(),
  })
);

export type GetAlertsSummaryRequestDto = PagePaginationRequestDto<
  {
    search: string | undefined;
    from: string;
    to: string;
  },
  | 'name'
  | 'avgResidents'
  | 'createdAlerts'
  | 'alertsPerResident'
  | 'createdFlags'
  | 'avgDaysToClose'
  | 'activeAlerts'
>;
export type GetAlertsSummaryResponseDto = z.infer<
  typeof GetAlertsSummaryResponseDtoSchema
>;

export const getAlertsSummary = (
  params: GetAlertsSummaryRequestDto,
  config?: AxiosRequestConfig<GetAlertsSummaryRequestDto>
) => {
  const transformedParams: GetAlertsSummaryRequestDto = {
    ...params,
    search: params.search?.trim() ? params.search.trim() : undefined,
  };

  return api
    .get('alerts/summary', { params: transformedParams, ...config })
    .then(responseContract(GetAlertsSummaryResponseDtoSchema));
};
